import { LbxSlider } from "../components/lbx-slider.vue";
Vue.component("lbx-slider", LbxSlider);
